import { useMutation } from "react-query";
import http from "infra/http";
import { EmpresaResponse } from "resources/types/empresa";
import { AxiosError, AxiosResponse } from "axios";

function useSaveFornecedor(id?: string) {
  return useMutation<
    AxiosResponse<{ data?: string; pessoaId: string }>,
    AxiosError,
    EmpresaResponse,
    any
  >(
    [`/v1/fornecedor`, id],
    (data: EmpresaResponse) => {
      data.pessoa.contatos = Array.isArray(data.pessoa.contatos)
        ? data.pessoa.contatos
        : [];

      if (!id) {
        return http.post<{ data: string; pessoaId: string }>(
          `/v1/fornecedor`,
          data
        );
      }

      return http.put<{ pessoaId: string }>(
        `/v1/fornecedor/${id}/pessoa`,
        data
      );
    },
    { retry: false }
  );
}

export default useSaveFornecedor;
